import { queryClient } from 'Context/QueryClientContext';
import { useMutation } from '@tanstack/react-query';
import { NotificationApiV2 } from 'Data/Notification.api.v2';
import { PREFERENCES_NOTIFICATIONS_QUERY_KEY } from 'Data/keys/QueryKeys';
import {
  IPreferencesRequest,
  IPreferences,
} from 'Data/interfaces/Preferences/IPreferencesApi';
import toastHandler from 'Utils/toastHandler';

export const useQueryCreateTopicPreference = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IPreferencesRequest) => {
      return NotificationApiV2.createTopicPreferences(variables);
    },
    onMutate: async (variables) => {
      const previousTopicPreferences = queryClient.getQueryData<IPreferences[]>(
        [PREFERENCES_NOTIFICATIONS_QUERY_KEY],
      );
      queryClient.setQueryData<IPreferences[]>(
        [PREFERENCES_NOTIFICATIONS_QUERY_KEY],
        (oldData) => {
          if (oldData) {
            return oldData.map((item) => {
              if (item.Action === variables.action) {
                return {
                  ...item,
                  Preference: variables.preference,
                };
              }
              return item;
            });
          }
          return oldData;
        },
      );
      return { previousTopicPreferences };
    },
    onError: async (e: any, variables, context) => {
      await queryClient.cancelQueries({ queryKey: [PREFERENCES_NOTIFICATIONS_QUERY_KEY] });
      queryClient.setQueryData(
        [PREFERENCES_NOTIFICATIONS_QUERY_KEY],
        context?.previousTopicPreferences,
      );
      const msg = 'Erro ao editar preferência de atividades de notificação';
      const error = e.errors ? (e.errors[0]?.Message || msg) : msg;
      toastHandler.showError(error);
    },
  });

  return {
    createTopicPreference: mutate,
    createTopicPreferenceAsync: mutateAsync,
    isLoading: isPending,
  };
};
